import React from 'react';
import MobileHeader from './mobileHeader';
import DesktopHeader from './desktopHeader';
import useBreakpoint from '../../lib/useBreakPoints';

const links = [
  { label: 'Hva vi tilbyr', href: 'tilbyr' },
  { label: 'Fremgansmåte', href: 'how' },
  { label: 'Kundeomtaler', href: 'kundeomtaler' },
  { label: 'FAQ`s', href: 'FAQ' },
  { label: 'Kontakt', href: 'kontakt' },
  { label: 'Verktøy', href: 'verktøy' },
  
  // legg til to til hvis du vil ha 6 totalt
];

export default function HeaderNew() {
  const isDesktop = useBreakpoint('(min-width: 768px)'); // ~Bootstrap lg

  return isDesktop ? (
    <DesktopHeader links={links} />
  ) : (
    <MobileHeader links={links} />
  );
}
